// src/components/ui/SmartGuideModal.js
import React from 'react';
import Modal from './Modal';
import { HelpCircle, PlayCircle } from 'lucide-react';

const SmartGuideModal = ({ isOpen, onClose, handleVoiceClick, startSmartGuide }) => {
    return (
        <Modal
            isOpen={isOpen}
            onClose={() => {
                if (window.speechSynthesis) {
                    window.speechSynthesis.pause();
                    window.speechSynthesis.cancel();
                }
                onClose();
            }}
            title="Smart Live Guide"
            icon={HelpCircle}
            iconColor="#0284C7"
            iconBg="linear-gradient(135deg, #E0F2FE, #7DD3FC)"
            maxWidth="400px"
        >
            <div style={{ marginTop: '10px' }}>
                <p style={{ fontSize: '9.5px', fontWeight: '600', color: '#64748B', marginBottom: '16px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    Aap kis topic ke bare me sikhna chahte hain? Niche Diye Gaye Options Me Se Chune.
                </p>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    
                    {/* 1. Add Worker */}
                    <div 
                        onClick={(e) => {
                            onClose();
                            handleVoiceClick(e, " Ye naya worker add karne ka guide hai.", () => startSmartGuide('add_worker'), 'guide-add-worker');
                        }} 
                        style={{ display: 'flex', justifyContent: 'space-between', padding: '12px', alignItems: 'center', background: '#f8fafc', borderRadius: '16px', cursor: 'pointer', border: '1px solid #e2e8f0', transition: 'all 0.2s' }}
                    >
                        <span style={{ fontSize: '11px', fontWeight: '700', color: '#0F172A' }}>1. Worker add kaise karein?</span>
                        <div style={{ background: 'linear-gradient(135deg, #E0E7FF, #A5B4FC)', padding: '6px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(79, 70, 229, 0.15)', flexShrink: 0 }}>
                            <PlayCircle size={14} color="#4338CA" />
                        </div>
                    </div>

                    {/* 2. Set Badli */}
                    <div 
                        onClick={(e) => {
                            onClose();
                            handleVoiceClick(e, " Ye badli duty lagane ka guide hai.", () => startSmartGuide('set_badli'), 'guide-set-badli');
                        }} 
                        style={{ display: 'flex', justifyContent: 'space-between', padding: '12px', alignItems: 'center', background: '#f8fafc', borderRadius: '16px', cursor: 'pointer', border: '1px solid #e2e8f0', transition: 'all 0.2s' }}
                    >
                        <span style={{ fontSize: '11px', fontWeight: '700', color: '#0F172A' }}>2. Badli kaise lagayein?</span>
                        <div style={{ background: 'linear-gradient(135deg, #E0E7FF, #A5B4FC)', padding: '6px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(79, 70, 229, 0.15)', flexShrink: 0 }}>
                            <PlayCircle size={14} color="#4338CA" />
                        </div>
                    </div>

                </div>
            </div>
        </Modal>
    );
};

export default SmartGuideModal;